module.exports = __webpack_public_path__ + "img/green_student.d65898ca.gif";